import "./listings-route.scss";

import * as React from "react";
import {Redirect} from "react-router-dom";
import {Types}    from "@Common/types";

import {cst, cstAssign} from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {AccountLayout} from "@Xpresso/routes/account/common/account-layout/account-layout";
import {InternalLink}  from "@Xpresso/routes/common/components/internal-link";
import {BRANCH_LEVEL}  from "@Xpresso/routes/common/logic/user-level";
import {SearchModal}   from "./search-modal/search-modal";

export const AccountAdminListingsRoute = () => cst<{
    session: Types.Apis.Loaders.LoadSessionContextNext
    userLevels: Types.Apis.Loaders.LoadUserLevelsNext,
    searchModal: Types.Xpresso.Account.Admin.Listings.SearchModal.Next,
}>(
    consumeContext("session"),
    consumeContext("userLevels"),
    ({session, userLevels}, next) => (
        userLevels.userLevel === BRANCH_LEVEL && session?.data?.branch && !session.data.branch.allowAddListing ? (
            <Redirect to="/account"/>
        ) : (
            next()
        )
    ),
    ({}, next) => AccountLayout({next, active: "listingsAdmin"}),
    cstAssign("searchModal", ({}, next) => SearchModal({next})),
    ({searchModal}) => (
        <div className="account-listings-tool-route-78sd">
            <div className="options-grid">
                <div className="item">
                    <label>Create a listing from scratch</label>
                    <InternalLink to="/account/admin/listing-form" xd-qa-type="button" xd-qa-name="Create a New Listing">Create a New Listing</InternalLink>
                </div>
                <div className="item">
                    <label>Create marketing materials or make changes to a listing</label>
                    <button onClick={() => searchModal.show({})} xd-qa-type="button" xd-qa-name="Search Existing Listings">Search Existing Listings</button>
                </div>
            </div>
        </div>
    )
);
